import Vue from 'vue';

Vue.mixin({
  methods: {
    getDate() {
      return this.filters.date ? this.filters.date : this.moment().format('YYYY-MM-DD');
    },
    setTime(time) {
      this.filters.time_start = time.time_start;
      this.filters.time_end = time.time_end;
      this.getItems();
    },
    getTime(time, value = '00:00:00') {
      if (time.HH) {
        return `${time.HH}:${time.mm}:00`;
      }

      return value;
    },
    updateDateFilter(date) {
      this.setFilter('date', this.moment(date.date).format('YYYY-MM-DD'));
    },
    setFilter(filter, value) {
      this.filters[filter] = value;
      this.getItems();
    },
    resetFilters() {
      for (let filter in this.filters) {
        if (filter == 'query') {
          this.filters[filter] = '';
          continue;
        }

        if (filter == 'time_start' || filter == 'time_end') {
          this.filters[filter] = { HH: '', mm: '' };
          continue;
        }

        this.filters[filter] = null;
      }

      this.resetPagination();
      this.getItems();
    },
    resetPagination() {
      this.filters.start = 0;
      this.filters.limit = 20;
    }
  }
});

